import { fetchSavedFilters, patchUserProfile } from "../../lib/api";
import { getData, patchData } from "../common-actions";
import { filterActions } from "./filter-slice";

const PROFILE_FIELD_SAVED_FILTERS = process.env.REACT_APP_PROFILE_FIELD_SAVED_FILTERS;

export const addFilter = (filter, signal) => {
    return (dispatch) => {
      dispatch(filterActions["addFilter"](filter));
    }
}

export const removeFilter = (filter, signal) => {
    return (dispatch) => {
      dispatch(filterActions["removeFilter"](filter));
    }
}

export const setFilter = (filter, signal) => {
  return (dispatch) => {
    dispatch(filterActions["setFilter"](filter));
  }
}

export const setQueueFilter = (filter, signal) => {
  return (dispatch) => {
    dispatch(filterActions["setQueueFilter"](filter));
  }
}

export const removeQueueFilter = (filter, signal) => {
  return (dispatch) => {
    dispatch(filterActions["removeQueueFilter"](filter));
  }
}

export const getSavedFilters = (token, userId, signal) => {
//  console.log("Getting saved filters", !PROFILE_FIELD_SAVED_FILTERS);

  if(!PROFILE_FIELD_SAVED_FILTERS) return;

  return getData({
    token: token,
    actions: filterActions,
    fetchFn: (token) => fetchSavedFilters(token, userId, signal),
    dataKey: "savedFilters",
    name: "get saved filters",
    setFunctionName: "setSavedFilters"
  });
}

export const setSavedFilters = (filters, signal) => {
  return (dispatch) => {
    dispatch(filterActions["setSavedFilters"](filters));
  }
}

export const patchSavedFilters = (token, userId, newFilters) => {
  if(!newFilters) return;

  //PATCH User
  return patchData({
    token: token,
    actions: filterActions,
    patchFn: (token) => patchUserProfile(token, userId, newFilters),    //Function in api to call
    dataKey: "savedFilters",
    name: "patch saved filters",
    setFunctionName: "setSavedFilters",
    patchData: newFilters,
    successMessage: "Filters saved successfully",
  });
}

export const clearFilters = () => {
  return (dispatch) => {
    dispatch(filterActions["clearFilters"]());
  }
}

export const clearQueueFilters = () => {
  return (dispatch) => {
    dispatch(filterActions["clearQueueFilters"]());
  }
}